import UnitTreeTools from "../Model/UnitTree.m"

export type StyleModel = {
    container: object,
    light: object,
    dark: object,
}

export class UnitTree extends UnitTreeTools {
    /*** Private Members ***/
    
    // Define your view's data model using private members here...
    
    /*** Protected Members ***/
    
    /*** Private Methods ***/
    
    /*** Protected Methods ***/
    
    /**
     * Initialize and perform setup for the class
     */
    protected _init = () => {
        // Initialize or set all members based on constructor argument values 
        // Perform additional setup here...
    }
    
    /*** Public Methods ***/
    
    /**
     * Class constructor. Calls _init() on the superclass. Add parameters as needed
     */
    public constructor() {
        super()
        this._init()
    }
    
    // Define public methods (including accessors and mutators) here...
    
}

// Instantiate the VM and export the instance
const UnitTreeVM = new UnitTree()

export default UnitTreeVM
